export const INACTIVITY_CHANNEL_NAME = 'periverse-auth-inactivity';
export const ACTIVITY_PUBLISH_THROTTLE_MS = 10_000;
export const INACTIVITY_TAB_ID_STORAGE_KEY = 'periverse.auth.inactivity.tabId';

// Genuine activity only. Focus and visibilitychange are used for revalidation.
export const ACTIVITY_EVENTS: Array<keyof WindowEventMap> = [
  'pointerdown',
  'keydown',
  'touchstart',
];
